import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AuthInput from './AuthInput';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiArrowRight, FiChevronLeft, FiCheck } = FiIcons;

export default function ForgotPasswordForm({ onBack }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setError('Enter a valid email address');
      return;
    }
    setError('');
    setLoading(true);
    setTimeout(() => { setLoading(false); setSent(true); }, 1200);
  };

  return (
    <div>
      <button onClick={onBack} className="flex items-center gap-1 font-sans text-sm text-stone-400 mb-6 active:text-stone-600 transition-colors">
        <SafeIcon icon={FiChevronLeft} /> Back to sign in
      </button>

      {sent ? (
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-8">
          <div className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center mx-auto mb-5">
            <SafeIcon icon={FiCheck} className="text-2xl text-emerald-500" />
          </div>
          <h2 className="font-serif text-3xl text-stone-900 mb-3">Check your inbox</h2>
          <p className="font-sans text-sm text-stone-400 leading-relaxed max-w-xs mx-auto">
            We've sent a password reset link to <span className="font-semibold text-stone-600">{email}</span>
          </p>
          <button onClick={onBack} className="mt-8 font-sans text-sm font-semibold text-stone-800 active:text-stone-500 transition-colors">
            Back to sign in
          </button>
        </motion.div>
      ) : (
        <>
          <div className="mb-8">
            <h2 className="font-serif text-3xl text-stone-900 mb-1">Reset password</h2>
            <p className="font-sans text-sm text-stone-400 leading-relaxed">
              Enter your email and we'll send you a link to reset your password.
            </p>
          </div>

          <AuthInput label="Email" type="email" value={email} onChange={v => { setEmail(v); setError(''); }} placeholder="you@example.com" icon={FiMail} error={error} />

          <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={handleSubmit}
            disabled={loading}
            className="w-full py-4 rounded-full font-sans font-semibold text-white text-base flex items-center justify-center gap-2 shadow-md mt-2 disabled:opacity-70"
            style={{ background: 'linear-gradient(135deg, #C07A52, #E8C97A)' }}
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin" />
            ) : (
              <><span>Send Reset Link</span><SafeIcon icon={FiArrowRight} /></>
            )}
          </motion.button>
        </>
      )}
    </div>
  );
}